var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGq = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 85.337h512v113.775H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 312.888h512v113.775H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M256 256.006L0 426.668V85.331z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M279.807 219.71v44.444c0 27.216 35.555 35.556 35.555 35.556s35.555-8.339 35.555-35.556V219.71h-71.11z",
  fill: "#dedde0"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#786145",
  d: "M306.477 256.156h17.778v25.778h-17.778z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M333.141 246.377c0-9.818-7.959-17.778-17.778-17.778s-17.778 7.959-17.778 17.778c-4.91 0-8.889 3.979-8.889 8.889s3.979 8.889 8.889 8.889h35.555c4.91 0 8.889-3.979 8.889-8.889s-3.979-8.889-8.888-8.889z",
  fill: "#6da544"
})));

export default SvgGq;